export default [
  {
    path: 'M502.07 350.4l87.34 47-83.3 51.07-87.34-44.35 83.3-53.76z m4-56.44l194.86 108.85-87.34 53.75s216.32 24.19 295.6 125c0 0 119.31 170.94-158.81 258.29 0 0-538.52 131.44-686.32-168.25l126.3-4s98.06 184.92 305 162.07c0 0 364.11-12.89 302.3-213.13 0 0-73.9-134.38-322.47-131.7L322 398.78 506.11 294z',
    fill: '#1D2088',
  },
  {
    path: 'M427.74 619.33L515.07 571l88.68 48.38-91.37 48.38-84.65-48.38z m104-463.28c136.19 9.41 360.92 42.36 427 202.35H823.79C776.39 150.08 294 120.2 221.91 327.28c-37.05 94.93 101 203.8 200.44 202.46 20.68-0.28 53.76-11.61 85.14-4.4L683 618.59l-175.69 103-192-109 88.21-51.89C259.74 545.71 54.45 466.82 81.81 332.47c34.39-168.8 313.71-185.82 449.9-176.41z',
    fill: '#5AA572',
  },
]
